import { getField, updateField } from "vuex-map-fields";
import qrPaymentInpt from "./qrPaymentInpt";
import billPaymentInpt from "./billPaymentInpt";
const getDefaultState = () => {
  return {
    billPaymentDstcCd: "0", // 공과금납부 구분코드(0: 전체, 1: 전기요금, 2: 수도요금)
  };
};

const payment = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      commit("qrPaymentInpt/resetState");
      commit("billPaymentInpt/resetState");
    },
  },
  modules: {
    qrPaymentInpt,
    billPaymentInpt,
  },
};

export default payment;
